import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@repo/ui/table'
import { cn, genWidths } from '@repo/ui/utils'

export function Loader() {
  // Random number of rows bewteen 3 and 7
  const rows = Array.from({ length: Math.floor(Math.random() * 5) + 3 })
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[360px]">
            <Skeleton className="bg-primary-200" />
          </TableHead>
          <TableHead>
            <Skeleton className="bg-primary-200" />
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((_, idx) => (
          <TableRow key={idx}>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

function Skeleton({ className }: { className?: string }) {
  const random = genWidths(1, 15, 45)[0]
  const width = random + '%'
  return (
    <div className={cn('bg-primary-50 h-4 animate-pulse rounded', className)} style={{ width }} />
  )
}
